import { useState, useEffect } from 'react'
import { useParams, Link, useNavigate} from "react-router-dom"
import { StarIcon } from '@heroicons/react/20/solid'
import { ArrowUturnLeftIcon } from '@heroicons/react/24/outline'
import { RadioGroup } from '@headlessui/react'
import { CATEGORIES } from '../../../data/Categories'



const reviews = { href: '#', average: 4, totalCount: 117 }

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function View({ handleClick, products }) {
    const navigate = useNavigate();
    const {id} = useParams();
    const product = products.find(prod => prod.id == id);
    // const [selectedColor, setSelectedColor] = useState(product.colors[0])
    const [ items, setItems] = useState([]);
    const category = product.category;

    const categoryItem = CATEGORIES.find(cat => cat.slug === category);

    useEffect(() => {
        const getItems = async () => {
            const categoryItems = products.filter(item => item.category === category);
            setItems(categoryItems)
        }
        getItems()
    }, [category])

  return (
    <div className="bg-white">
      <div className="px-4 pb-16 pt-24 sm:px-6 lg:px-12 lg:pb-24 lg:pt-28">
      <div className='flex items-center pb-2 lg:pb-0'>
                <Link onClick={() => navigate(-1)} className='bg-black p-1.5 lg:p-2 rounded-full'>
                    <ArrowUturnLeftIcon className='h-5 text-white' />
                </Link>
        </div>
        {/* Product info */}
        <div data-aos="zoom-in" className="mx-auto max-w-2xl  lg:grid lg:max-w-7xl lg:grid-cols-2 lg:grid-rows-[auto,auto,1fr] lg:gap-x-8 ">
        <div className=" col-start-2 row-start-1  lg:pb-0 lg:pr-8 lg:pt-0">
            {/* Product image */}
            <div>
              <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7">
                <img className='h-full w-full object-cover object-center' src={product.image} alt={product.slug}/>
              </div>
            </div>
          </div>
          

          {/* Options */}
          <div className='lg:flex lg:items-center'>
          <div className="mt-4 lg:row-span-3 row-start-2 sm:col-start-1   lg:mt-0">
            
            <div className="lg:col-span-2 lg:pr-8">
                {/* <p className='text-2xl lg:text-4xl font-light'>{product.slug}</p> */}
                <h1 className="text-5xl lg:text-7xl font-bold tracking-tight text-black sm:text-3xl">{product.name}</h1>
            </div>
            <h2 className="sr-only">Product information</h2>
            <div className="space-y-6 py-6">
                <p className="text-base text-gray-900">{product.description}</p>
              </div>

            {/* Reviews */}
            {/* <div className="mt-6">
              <h3 className="sr-only">Reviews</h3>
              <div className="flex items-center">
                <div className="flex items-center">
                  {[0, 1, 2, 3, 4].map((rating) => (
                    <StarIcon
                      key={rating}
                      className={classNames(
                        reviews.average > rating ? 'text-gray-900' : 'text-gray-200',
                        'h-5 w-5 flex-shrink-0'
                      )}
                      aria-hidden="true"
                    />
                  ))}
                </div>
                <p className="sr-only">{reviews.average} out of 5 stars</p>
                <a href={reviews.href} className="ml-3 text-sm font-medium text-gray-600 hover:text-gray-500">
                  {reviews.totalCount} reviews
                </a>
              </div>
            </div> */}

            {/* <form className="mt-6"> */}
              <div>
                {/* <h3 className="text-sm font-medium text-gray-900">Color</h3> */}

                {/* <RadioGroup value={selectedColor} onChange={setSelectedColor} className="mt-4">
                  <RadioGroup.Label className="sr-only">Choose a color</RadioGroup.Label>
                  <div className="flex items-center space-x-3">
                    {product.colors.map((color) => (
                      <RadioGroup.Option
                        key={color.name}
                        value={color}
                        className={({ active, checked }) =>
                          classNames(
                            color.selectedClass,
                            active && checked ? 'ring ring-offset-1' : '',
                            !active && checked ? 'ring-2' : '',
                            'relative -m-0.5 flex cursor-pointer items-center justify-center rounded-full p-0.5 focus:outline-none'
                          )
                        }
                      >
                        <RadioGroup.Label as="span" className="sr-only">
                          {color.name}
                        </RadioGroup.Label>
                        <span
                          aria-hidden="true"
                          className={classNames(
                            color.class,
                            'h-8 w-8 rounded-full border border-black border-opacity-10'
                          )}
                        />
                      </RadioGroup.Option>
                    ))}
                  </div>
                </RadioGroup> */}
              </div>
              {/* </form> */}
            <div className='grid grid-cols-1 lg:grid-cols-4 items-end'>
                <p className="text-2xl lg:text-3xlmb-2 tracking-tight text-gray-900 flex items-end">Prix :  <span className='text-2xl lg:text-3xl font-medium tracking-tight ml-1 text-gray-900'> {product.price}$</span></p>
              <button onClick={() => handleClick(product)}
                className="mt-10 uppercase col-span-2 flex w-full items-center justify-center rounded-md border border-transparent bg-black px-8 py-3 text-base font-medium text-white hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2">
                Ajouter au panier
              </button>
              </div>
            
          </div>
          </div>
        </div>

        <div>
        <div className="pt-16 lg:pt-16">
        <div className=' mb-5 flex justify-between items-center'>
          <h2 className='text-2xl font-light tracking-tight text-black sm:text-3xl'>Produits de même catégorie</h2>
        </div>
        <div className="grid grid-cols-3 gap-x-6 gap-y-10 sm:grid-cols-4 lg:grid-cols-5 xl:grid-cols-5 xl:gap-x-8">
          {items.map((product, index) => (
            <div data-aos="fade-up">
              <Link  to={`/product/${product.id}`} className="group" >
                <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7">
                  <img
                    src={product.image}
                    alt={product.slug}
                    className="h-full w-full object-cover object-center group-hover:opacity-75"
                  />
                </div>
                <div className='flex justify-between items-end'>
                  <h3 className="mt-4 text-sm text-gray-900">{product.name}</h3>
                  <p className="mt-1 text-base sm:text-lg font-medium text-gray-900">${product.price}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
        </div>
      </div>
    </div>
  )
}
